import { Box, Center } from '@chakra-ui/react';
import { Form } from 'formik';
import { getSectionType } from '../../handlers/utils';

const RSForm = ({props,formikProps}) => {
  return (
    <Form>
      <Box
        minHeight={['540px', null, '600px']}
      >
        <Center
          paddingLeft={['20px', '40px', '80px']}
          paddingRight={['20px', '40px', '80px']}
          paddingTop={['15px', '30px', '60px']}
          paddingBottom={['30px', '40px', '60px']}
        >
          <Box width="100%" maxWidth="1400px">
            {getSectionType(props, formikProps)}
          </Box>
        </Center>
      </Box>
    </Form>
  );
};

export default RSForm;
